import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './Laser.metadata.json5';
import OperatorsInfo from '../OperatorsInfo/OperatorsInfo';
import MachineDetails from '../MachineDetails/MachineDetails';

function Laser(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('Laser');
const modelVM = _.get(submissionVM, pathUpdated);

modelVM.value.isValidationReq = true;


// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        operatorsInfoComponent: {
            data: modelVM.opeInfExposures,
            updateWizardData,
            submissionVM,
            operatorInfoPath: `${pathUpdated}.opeInfExposures`
        },
        machineDetailsComponent: {
            data: modelVM.macDetExposures,
            updateWizardData,
            submissionVM,
            machineDetailsPath: `${pathUpdated}.macDetExposures`
        },
        othLasSerpledesFie: {
            visible: _.get(modelVM, 'othLasSerFie.value') !== undefined && _.get(modelVM, 'othLasSerFie.value')
        },
        othPulLigSerpledesFie: {
            visible: _.get(modelVM, 'othSerPulLigFie.value') !== undefined && _.get(modelVM, 'othSerPulLigFie.value')
        },
        howmanyeaisserreckfilFie: {
            visible: _.get(modelVM, 'doyoukeecopofallclrecFie.value')
        },
        pledescFie: {
            visible: _.get(modelVM, 'doyouexptothecliwhtFie.value')
        },
        pledesFie: {
            visible: _.get(modelVM, 'doyouexptothecliwhtreFie.value')
        },
        IfyeslisalllocmetotreFie: {
            visible: _.get(modelVM, 'doyouproanyofflasttreFie.value')
        },
        howlondoyouwaiafttHouFie: {
            visible: _.get(modelVM, 'doyoucomaskipattestreFie.value') !== undefined
                && _.get(modelVM, 'doyoucomaskipattestreFie.value') === true
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            operatorsInfoComponent: OperatorsInfo,
            machineDetailsComponent: MachineDetails
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

Laser.propTypes = wizardProps;
export default withRouter(Laser);
